<template lang="pug">
  pagina
    breadcrumb(slot="breadcrumb", :itens="this.breadcrumb")
    h1(slot="principal") Essa página não foi encontrada.
    sidebar(slot="lateral")
</template>

<script>
  import Breadcrumb from 'MODULES/Breadcrumb'
  import Pagina from 'MODULES/Pagina'
  import Sidebar from 'MODULES/Sidebar'
  export default {
    components: {
      Breadcrumb,
      Pagina,
      Sidebar
    },
    data () {
      return {
        breadcrumb: [
          { nome: 'Ops!' }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Error.vue?7e18cb56